module.exports = __webpack_public_path__ + "img/selection_process.9aad9ad7.svg";